export const WORK_ORDER_FORM_CONFIG_FIELD_TYPES = {
  CUSTOM_FIELDS: "customFields",
  PARTS: "parts",
  DESCRIPTION: "description",
};
export const WORK_ORDER_FORM_CONFIG_FIELD_RANK = {
  [WORK_ORDER_FORM_CONFIG_FIELD_TYPES.DESCRIPTION]: 0,
  [WORK_ORDER_FORM_CONFIG_FIELD_TYPES.PARTS]: 1,
  [WORK_ORDER_FORM_CONFIG_FIELD_TYPES.CUSTOM_FIELDS]: 2,
};

export const WORK_ORDER_FORM_CUSTOM_FIELD_DESCRIPTION_LENGTH = 30;
